export default {
  StateAndCountryAutocomplete__NO_MATCH_FOUND: "No match found",
};
